import React, {useMemo, useRef, useState} from "react";
import AsyncSelect from "react-select/async";
import axios from "axios";
import debounce from "lodash.debounce";
import {Button} from "@material-tailwind/react";
import {PlusIcon} from "@heroicons/react/24/outline";

const RoadSelect = ({value, onChange}) => {
    const [inputValue, setInputValue] = useState("");
    const selectRef = useRef();

    const debouncedFetch = useMemo(() =>
            debounce(async (inputValue, callback) => {
                try {
                    const response = await axios.get("/roads/search.json", {
                        params: {query: inputValue}
                    });

                    const options = response.data.map((road) => ({
                        label: road.name,
                        value: road.id
                    }));

                    callback(options);
                } catch (error) {
                    console.error("Error al buscar calle:", error);
                    callback([]);
                }
            }, 400)
        , []);

    const getCSRFToken = () => {
        const token = document.querySelector('meta[name="csrf-token"]');
        return token ? token.content : "";
    };

    const loadOptions = (inputValue, callback) => {
        if (inputValue.length < 2) {
            callback([]);
            return;
        }
        debouncedFetch(inputValue, callback);
    };

    const handleInputChange = (newValue) => {
        setInputValue(newValue.toUpperCase());
        return newValue;
    };

    const noOptionsMessage = () => {
        if (!inputValue || inputValue.trim().length < 2) {
            return "Escribe al menos 2 letras...";
        }

        return (
            <Button onMouseDown={async (e) => {
                e.preventDefault();
                const newOption = await handleCreateRoad()

                if (newOption) {
                    onChange(newOption);
                    selectRef.current?.blur();
                }
            }}
                    className="w-full bg-green-500 hover:bg-green-600 text-white rounded-md px-5 py-3 font-semibold flex items-center gap-3"
            >
                <PlusIcon className="h-5 w-5"/>
                Agregar calle: "{inputValue}"
            </Button>
        );
    };

    const handleCreateRoad = async () => {
        try {
            const response = await axios.post("/roads.json", {
                road: {name: inputValue}
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "X-CSRF-Token": getCSRFToken(),
                }
            });

            const created = response.data;
            return {
                label: created.name,
                value: created.id
            };
        } catch (err) {
            console.error("Error al crear nueva colonia:", err);
            return null;
        }
    }

    return (
        <AsyncSelect
            ref={selectRef}
            cacheOptions
            defaultOptions
            loadOptions={loadOptions}
            onInputChange={handleInputChange}
            value={value}
            onChange={onChange}
            placeholder="Escribe para buscar calle..."
            className='focus:outline-none focus:ring-0'
            noOptionsMessage={noOptionsMessage}
        />
    );
};

export default RoadSelect;
